import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function SocialLinkedIn({ idVariant = '', className }: Props) {
  return (
    <IconBase name="social-linked-in" w={16} className={className}>
      <g clipPath={`url(#sociallinkedin_${idVariant}_clip0_2565_10707)`}>
      <path fillRule="evenodd" clipRule="evenodd" d="M1.77778 16H14.2222C15.2041 16 16 15.2041 16 14.2222V1.77778C16 0.795938 15.2041 0 14.2222 0H1.77778C0.795938 0 0 0.795938 0 1.77778V14.2222C0 15.2041 0.795938 16 1.77778 16Z" fill="currentColor"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M13.7782 13.7782H11.4039V9.73424C11.4039 8.62549 10.9826 8.00589 10.105 8.00589C9.15035 8.00589 8.65156 8.65068 8.65156 9.73424V13.7782H6.3634V6.07451H8.65156V7.1122C8.65156 7.1122 9.33956 5.83915 10.9743 5.83915C12.6084 5.83915 13.7782 6.83698 13.7782 8.9007V13.7782ZM3.63362 5.06577C2.85422 5.06577 2.22266 4.42925 2.22266 3.64421C2.22266 2.85918 2.85422 2.22266 3.63362 2.22266C4.41302 2.22266 5.04421 2.85918 5.04421 3.64421C5.04421 4.42925 4.41302 5.06577 3.63362 5.06577ZM2.45211 13.7782H4.83808V6.07451H2.45211V13.7782Z" fill="white"/>
      </g>
      <defs>
      <clipPath id={`sociallinkedin_${idVariant}_clip0_2565_10707`}>
      <rect width="16" height="16" fill="currentColor"/>
      </clipPath>
      </defs>
    </IconBase>
  )
}

export default SocialLinkedIn
